<template>
  <v-card tile>
    <v-card-title class="text-xs-center">
      <v-icon medium color="green darken-2" class="mr-1">fas fa-users</v-icon>
      <span class="subheading">总到款统计排名前30的教师名单</span>
      <v-spacer />
    </v-card-title>
    <v-data-table
      :headers="headers"
      :loading="loading"
      hide-actions
      item-key="dbid"
      :disable-initial-sort="true"
      :items="items"
      no-data-text="没有数据。"
      no-results-text="没有符合条件的记录。"
    >
      <template slot="items" slot-scope="props">
        <td>
          {{ props.index + 1}}
        </td>
        <td>{{props.item.name}}</td>
        <td>{{props.item.tno}}</td>
        <td>{{props.item.cname}}</td>
        <td>{{props.item.all_amount}}</td>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
  const uri = '/api/proj/report/teacher-project-level-statistics';
  export default {
    props: ["startDate", "endDate"],
    name: "TeacherProjectLevelStatistics",
    data() {
      return {
        loading: false,
        items: [],
        name:"",
        tno:"",
        cname:"",
        all_mount:"",
        // 表头
        headers: [
          {text: '#', align: 'left', sortable: false, value: 'dbid', width: "2rem"},
          {text: '教师名称', align: 'left', sortable: true, value: 'name'},
          {text: '教师工号', align: 'left', sortable: true, value: 'tno'},
          {text: '学院名称', align: 'left', sortable: true, value: 'cname'},
          {text: '总到款（万元）', align: 'left', sortable: true, value: 'all_amount'}
        ]
      }
    },
    watch: {
      "startDate": 'get',
      "endDate": 'get'
    },
    created() {
      this.get();
    },
    mounted() {
    },
    computed: {},
    methods: {
      get() {
        if (this.loading || !this.startDate || !this.endDate) {
          return
        }
        this.loading = true;
        let params = {"incomeDateStart": this.startDate, "incomeDateEnd": this.endDate};
        this.axios.get(uri, {params: params}).then(
          rsp => {
            this.items = rsp.data;
            this.loading = false;
          })
      }
    }
  }
</script>

<style scoped>

</style>
